export const MobileMenuENUSTranslations = {
  mobileMenuCloseButtonLabel: 'Close menu button',
};
